// Core
import React from 'react';
// Styles
import './Button.css';
// Components
import Icon from '../Icon/Icon.js';

const Button = props => {
    return (
        <button {...props}>
            {props.icon ? <Icon icon={props.icon} /> : null} {props.action}
            {props.children}
        </button>
    );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js